/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ConvertedInputs */

const cs_enum_converted = /** @type {(inputs: Enum_ConvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkonvertován`)
};

const en_enum_converted = /** @type {(inputs: Enum_ConvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converted`)
};

/**
* | output |
* | --- |
* | "Converted" |
*
* @param {Enum_ConvertedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_converted = /** @type {((inputs?: Enum_ConvertedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ConvertedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_converted(inputs)
	return cs_enum_converted(inputs)
});